import { SlotImage, usePageAsset } from "~/components/ui";
import type { PageAssetSlot } from "~/lib/assets/slots";

/**
 * T872 S3 — the real capture of the app in beta (October delivery
 * `components/ProductCapture.html`, `tfc-media.css`): a phone-shaped frame, 350px wide,
 * with its caption split in two voices. The image is a slot the founder manages from the
 * Back Office — the Home's `home-product-capture`, Método's `method-practice-capture`
 * (S4); while it is empty nothing renders, figure and caption alike.
 */
export function ProductCapture({
  caption,
  note,
  slot = "home-product-capture",
}: {
  caption: string;
  note: string;
  slot?: Extract<PageAssetSlot, "home-product-capture" | "method-practice-capture">;
}) {
  const asset = usePageAsset(slot);
  if (!asset?.imageUrls?.heroMobile) return null;
  return (
    <figure className="pub-product-proof">
      <div className="pub-product-frame">
        <SlotImage slot={slot} variant="heroMobile" loading="lazy" />
      </div>
      <figcaption>
        {caption}
        <span>{note}</span>
      </figcaption>
    </figure>
  );
}
